import React from 'react';
import { Link } from 'react-router-dom';

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const CtaSection = (props) => {
  const {
    hclass,
    eyebrow = 'Need Shipping Assistance?',
    title = 'Speak with Ferry Gold Shipping for tracking, booking, and delivery support.',
    buttonText = 'Contact Our Team',
    buttonLink = '/contact',
    email = 'support@ferrygoldshipping.com',
    address = 'Yau Lee Centre, UNIT 78, 3/F, 45 Hoi Yuen Rd, Kwun Tong, Hong Kong',
  } = props;

  return (
    <div className={'' + hclass}>
      <div className='container'>
        <div className='cta-wrapr'>
          <div className='wpo-section-title'>
            <h2>{eyebrow}</h2>
            <h3>{title}</h3>
            <Link onClick={ClickHandler} to={buttonLink} className='theme-btn'>
              {buttonText}
            </Link>
          </div>
          <div className='contact-info'>
            <div className='item'>
              <div className='icon'>
                <i className='flaticon-email'></i>
              </div>
              <div className='text'>
                <span>Send Us Email</span>
                <p>{email}</p>
              </div>
            </div>
            <div className='item'>
              <div className='icon'>
                <i className='flaticon-location'></i>
              </div>
              <div className='text'>
                <span>Visit Our Office</span>
                <p>{address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CtaSection;
